import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './../../assets/styles/constants.css';
import './../../assets/styles/fonts.css';
import './PageHeader.css';

const pageHeaderTooltip = tooltipMessage => (
  <Tooltip id="data-bar__item-tooltip">{tooltipMessage}</Tooltip>
);

const PageHeader = props => {
  const { title, imageUrl, centerTitle, tooltip } = props;

  const titleStyle = centerTitle
    ? 'page-header__title page-header__title--centered'
    : 'page-header__title';

  const wrappedTitle = tooltip ? (
    <h1 className={titleStyle}>
      {title}
      <OverlayTrigger placement="bottom" overlay={pageHeaderTooltip(tooltip)}>
        <i className="page-header__title-tooltip fa fa-info-circle" />
      </OverlayTrigger>
    </h1>
  ) : (
    <h1 className={titleStyle}>{title}</h1>
  );

  return (
    <div className="page-header-root">
      {wrappedTitle}
      {imageUrl && (
        <img
          className="page-header__image"
          src={imageUrl}
          alt={`${title} logo`}
        />
      )}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  centerTitle: PropTypes.bool,
  tooltip: PropTypes.string
};

PageHeader.defaultProps = {
  imageUrl: '',
  centerTitle: false,
  tooltip: ''
};

export default PageHeader;
